<template>
  <nav ref="nav" class="admin-nav">
    <div class="nav-brand">🔐 Admin — Fidélité Marché</div>

    <div class="nav-links">
      <router-link to="/admin/dashboard">📊 Stats</router-link>

      <div class="nav-group" v-for="group in groups" :key="group.id" :class="{ active: isGroupActive(group) }">
        <button class="nav-group-btn" type="button" @click="toggleGroup(group.id)">
          <span>{{ group.icon }} {{ group.label }}</span>
          <span class="chevron" :class="{ open: menuGroupe === group.id }">▾</span>
        </button>
        <div class="dropdown" v-if="menuGroupe === group.id">
          <router-link v-for="item in group.items" :key="item.to" :to="item.to">
            {{ item.icon }} {{ item.label }}
          </router-link>
        </div>
      </div>

      <router-link to="/admin/journees">📅 Journées</router-link>
    </div>

    <button class="btn-logout desktop-only" @click="logout">Déconnexion</button>

    <button class="hamburger mobile-only" @click="menuOuvert = !menuOuvert" :class="{ open: menuOuvert }">
      <span></span><span></span><span></span>
    </button>

    <div class="mobile-menu" :class="{ open: menuOuvert }">
      <router-link to="/admin/dashboard">📊 Stats</router-link>

      <div class="mobile-group" v-for="group in groups" :key="group.id">
        <button
          class="mobile-group-btn"
          :class="{ active: isGroupActive(group) }"
          type="button"
          @click="toggleMobileGroup(group.id)"
        >
          <span>{{ group.icon }} {{ group.label }}</span>
          <span class="chevron" :class="{ open: menuMobileGroupe === group.id }">▾</span>
        </button>
        <div class="mobile-submenu" v-if="menuMobileGroupe === group.id || isGroupActive(group)">
          <router-link v-for="item in group.items" :key="item.to" :to="item.to">
            {{ item.icon }} {{ item.label }}
          </router-link>
        </div>
      </div>

      <router-link to="/admin/journees">📅 Journées</router-link>
      <button class="btn-logout-mobile" @click="logout">Déconnexion</button>
    </div>
  </nav>
  <div class="overlay" v-if="menuOuvert || menuGroupe" @click="fermerMenus"></div>
</template>

<script>
export default {
  name: 'AdminNav',
  data() {
    return {
      menuOuvert: false,
      menuGroupe: '',
      menuMobileGroupe: '',
      groups: [
        {
          id: 'marchands',
          label: 'Marchands',
          icon: '🏪',
          items: [
            { to: '/admin/commercants', label: 'Commerçants', icon: '🏪' }
          ]
        },
        {
          id: 'clients',
          label: 'Clients',
          icon: '👥',
          items: [
            { to: '/admin/clients', label: 'Clients', icon: '👥' },
            { to: '/admin/cartes', label: 'Cartes', icon: '🎴' }
          ]
        },
        {
          id: 'finance',
          label: 'Finance',
          icon: '🧾',
          items: [
            { to: '/admin/facturation', label: 'Facturation', icon: '🧾' },
            { to: '/admin/gestion-financiere', label: 'Pilotage financier', icon: '💶' },
            { to: '/admin/comptabilite-micro', label: 'Comptabilité micro', icon: '📒' },
            { to: '/admin/justificatifs', label: 'Justificatifs', icon: '📎' }
          ]
        },
        {
          id: 'parametres',
          label: 'Paramètres',
          icon: '⚙️',
          items: [
            { to: '/admin/entreprise', label: 'Entreprise', icon: '⚙️' },
            { to: '/admin/sql', label: 'SQL', icon: '💾' }
          ]
        }
      ]
    }
  },
  mounted() {
    document.body.classList.add('admin-layout')
    document.addEventListener('click', this.handleOutsideClick)
  },
  unmounted() {
    document.body.classList.remove('admin-layout')
    document.removeEventListener('click', this.handleOutsideClick)
  },
  watch: {
    $route() {
      this.fermerMenus()
    }
  },
  methods: {
    isGroupActive(group) {
      return group.items.some(item => item.to === this.$route.path)
    },
    toggleGroup(groupId) {
      this.menuGroupe = this.menuGroupe === groupId ? '' : groupId
    },
    toggleMobileGroup(groupId) {
      this.menuMobileGroupe = this.menuMobileGroupe === groupId ? '' : groupId
    },
    fermerMenus() {
      this.menuOuvert = false
      this.menuGroupe = ''
      this.menuMobileGroupe = ''
    },
    handleOutsideClick(event) {
      if (!this.$refs.nav?.contains(event.target)) this.fermerMenus()
    },
    logout() {
      localStorage.removeItem('admin_token')
      this.$router.push('/admin')
    }
  }
}
</script>

<style scoped>
.admin-nav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #1a202c;
  color: white;
  padding: 0 24px;
  height: 56px;
  width: 100%;
  max-width: 100%;
  position: sticky;
  top: 0;
  z-index: 100;
  gap: 16px;
  overflow: visible;
}

.nav-brand { font-size: 15px; font-weight: 700; white-space: nowrap; min-width: 0; }

.nav-links {
  display: flex;
  align-items: center;
  gap: 4px;
  min-width: 0;
}

.nav-links a,
.nav-group-btn {
  color: rgba(255,255,255,0.75);
  text-decoration: none;
  padding: 6px 12px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 500;
  transition: all 0.2s;
  white-space: nowrap;
}

.nav-group {
  position: relative;
}

.nav-group-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: transparent;
  border: 0;
  cursor: pointer;
}

.nav-links a:hover,
.nav-links a.router-link-active,
.nav-group.active .nav-group-btn,
.nav-group-btn:hover {
  background: rgba(255,255,255,0.12);
  color: white;
}

.chevron {
  display: inline-block;
  font-size: 11px;
  transition: transform 0.2s;
}
.chevron.open { transform: rotate(180deg); }

.dropdown {
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  min-width: 220px;
  padding: 6px;
  border-radius: 8px;
  background: #1a202c;
  box-shadow: 0 12px 28px rgba(0,0,0,0.28);
  z-index: 120;
}
.dropdown a {
  display: block;
  padding: 10px 12px;
}

.btn-logout {
  background: rgba(255,255,255,0.1);
  border: none; color: white;
  padding: 6px 14px; border-radius: 8px;
  font-size: 13px; cursor: pointer; white-space: nowrap;
}
.btn-logout:hover { background: rgba(255,255,255,0.2); }

.hamburger {
  display: none;
  flex-direction: column;
  justify-content: space-between;
  width: 26px; height: 18px;
  background: none; border: none;
  cursor: pointer; padding: 0;
}
.hamburger span {
  display: block; height: 2px;
  background: white; border-radius: 2px;
  transition: all 0.3s;
}
.hamburger.open span:nth-child(1) { transform: translateY(8px) rotate(45deg); }
.hamburger.open span:nth-child(2) { opacity: 0; }
.hamburger.open span:nth-child(3) { transform: translateY(-8px) rotate(-45deg); }

.mobile-menu {
  display: none;
  position: fixed;
  top: 56px; left: 0; right: 0;
  max-height: calc(100vh - 56px);
  overflow-y: auto;
  background: #1a202c;
  flex-direction: column;
  padding: 8px 0;
  z-index: 99;
  box-shadow: 0 8px 24px rgba(0,0,0,0.3);
  opacity: 0;
  transition: opacity 0.2s;
  pointer-events: none;
}
.mobile-menu.open {
  display: flex;
  opacity: 1;
  pointer-events: all;
}
.mobile-menu a,
.mobile-group-btn {
  color: rgba(255,255,255,0.9);
  text-decoration: none;
  padding: 14px 20px;
  font-size: 15px;
  font-weight: 500;
  border-bottom: 1px solid rgba(255,255,255,0.08);
}
.mobile-group-btn {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  background: transparent;
  border-top: 0;
  border-left: 0;
  border-right: 0;
  cursor: pointer;
  text-align: left;
}
.mobile-submenu {
  display: grid;
  background: rgba(0,0,0,0.14);
}
.mobile-submenu a {
  padding-left: 36px;
  font-size: 14px;
}
.mobile-menu a:hover,
.mobile-menu a.router-link-active,
.mobile-group-btn.active,
.mobile-group-btn:hover {
  background: rgba(255,255,255,0.1);
  color: white;
}
.btn-logout-mobile {
  background: none; border: none;
  color: rgba(255,255,255,0.7);
  padding: 14px 20px; font-size: 15px;
  text-align: left; cursor: pointer; width: 100%;
}
.overlay { position: fixed; inset: 0; z-index: 98; background: rgba(0,0,0,0.4); }

@media (max-width: 1180px) {
  .nav-brand { font-size: 14px; }
  .nav-links { display: none; }
  .desktop-only { display: none; }
  .hamburger { display: flex; }
  .mobile-menu { top: 56px; }
}

@media (max-width: 420px) {
  .admin-nav { padding: 0 16px; }
  .nav-brand {
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>
